var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8729 6.61109C19.6942 6.36667 15.4371 0.626465 9.9999 0.626465C4.56274 0.626465 0.305391 6.36667 0.126914 6.61085C-0.0423048 6.84273 -0.0423048 7.15722 0.126914 7.3891C0.305391 7.63351 4.56274 13.3737 9.9999 13.3737C15.4371 13.3737 19.6942 7.63347 19.8729 7.38929C20.0423 7.15746 20.0423 6.84273 19.8729 6.61109ZM9.9999 12.055C5.99486 12.055 2.52606 8.24515 1.49922 6.99964C2.52473 5.75304 5.98626 1.94514 9.9999 1.94514C14.0048 1.94514 17.4733 5.75437 18.5006 7.00054C17.4751 8.24711 14.0135 12.055 9.9999 12.055Z",
    fill: "#98999E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.04395C7.81868 3.04395 6.04395 4.81868 6.04395 7.00001C6.04395 9.18134 7.81868 10.9561 10 10.9561C12.1813 10.9561 13.9561 9.18134 13.9561 7.00001C13.9561 4.81868 12.1813 3.04395 10 3.04395ZM10 9.63736C8.54571 9.63736 7.36266 8.45427 7.36266 7.00001C7.36266 5.54575 8.54575 4.36266 10 4.36266C11.4543 4.36266 12.6374 5.54575 12.6374 7.00001C12.6374 8.45427 11.4543 9.63736 10 9.63736Z",
    fill: "#98999E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.3de896dafcac3a766652bc69f60ad16e.svg";
export { ForwardRef as ReactComponent };